import { Button, Notification, Stack, Text, ThemeProps, Title } from "common/components/ui";
import { ElevioButton } from "common/elevio/ElevioButton";
import styled from "@emotion/styled";

export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ModalTitle = styled(Title)<ThemeProps>(
  ({ theme }) => `
    text-align: center;
    margin-bottom: ${theme.spacing.S6};
`
);

export const Subtitle = styled(Text)<ThemeProps>(
  ({ theme }) => `
    a {
      font-weight: ${theme.font.weight.BOLD};
    }
  `
);

export const StyledText = styled(Text)<ThemeProps>(
  ({ theme }) => `
    margin-top: ${theme.spacing.S1};
`
);

export const DropzoneWrapper = styled.div<ThemeProps>(
  ({ theme }) => `
    margin: ${theme.spacing.S4} 0 ${theme.spacing.S2};
`
);

export const NotificationMessage = styled(Notification)<ThemeProps>(
  ({ theme }) => `
    margin-top: ${theme.spacing.S4};
`
);

export const StyledStack = styled(Stack)<ThemeProps>(
  ({ theme }) => `
    margin-top: ${theme.spacing.S6};
`
);

export const HelpButton = styled(ElevioButton)`
  flex: 1;
`;

export const ActionButton = styled(Button)`
  flex: 1;
`;
